import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * Returns { hasAccess, loading } for HR Tools page.
 * - Superadmin: always has access
 * - Admin: access only if userData.hrToolsAccess === true in Firestore
 * - Employee: never has access
 */
const useHRToolsAccess = () => {
  const { userData, loading: authLoading } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;

    if (!userData) {
      setHasAccess(false);
      setLoading(false);
      return;
    }

    if (userData.role === "superadmin") {
      setHasAccess(true);
    } else if (userData.role === "admin" && userData.hrToolsAccess === true) {
      setHasAccess(true);
    } else {
      setHasAccess(false);
    }

    setLoading(false);
  }, [userData, authLoading]);

  return { hasAccess, loading };
};

export default useHRToolsAccess;
